import { CloseOutlined } from '@ant-design/icons';

import { Button, Select } from '../../../../components/ui';
import { useT } from '../../../../i18n';
import { NHAN_VAI_TRO } from '../../constants';
import { thanhNguoiThamGia, VAI_TRO_THAM_GIA } from '../../nghiep-vu/nhiem-vu';
import type { DonViDanhBa, NguoiThamGiaVao, VaiTroThamGia } from '../../types-nhiem-vu';
import { UserAvatar } from './UserAvatar';
import { UserSearchSelect } from './UserSearchSelect';

interface Props {
  id?: string;
  value: NguoiThamGiaVao[];
  onChange: (next: NguoiThamGiaVao[]) => void;
  orgs: DonViDanhBa[];
  invalid?: boolean;
}

export function ParticipantPicker({ id, value, onChange, orgs, invalid }: Props) {
  const { t } = useT();
  const roleOptions = VAI_TRO_THAM_GIA.map((r) => ({ value: r, label: t(NHAN_VAI_TRO[r]) }));
  const setRole = (userId: string, role: VaiTroThamGia) =>
    onChange(value.map((p) => (p.user_id === userId ? { ...p, role } : p)));

  return (
    <div className="space-y-2">
      <UserSearchSelect
        id={id}
        invalid={invalid}
        excludeIds={value.map((p) => p.user_id)}
        onPick={(user) => {
          // Người đầu tiên mặc định chủ trì; những người sau mặc định phối hợp.
          const role: VaiTroThamGia = value.some((p) => p.role === 'CHU_TRI') ? 'PHOI_HOP' : 'CHU_TRI';
          onChange([...value, thanhNguoiThamGia(user, orgs, role)]);
        }}
      />
      {value.length === 0 ? (
        <p className="text-xs text-content-muted">{t('vanBanNhiemVu.form.chuaChonNguoi')}</p>
      ) : (
        <ul className="divide-y divide-default rounded-lg border border-default">
          {value.map((p) => (
            <li key={p.user_id} className="flex items-center gap-2 px-3 py-2">
              <UserAvatar name={p.user_name} />
              <div className="min-w-0 flex-1">
                <p className="truncate text-sm text-content-primary">{p.user_name}</p>
                <p className="truncate text-xs text-content-muted">
                  {[p.org_name, p.user_email].filter(Boolean).join(' · ')}
                </p>
              </div>
              <Select<VaiTroThamGia>
                size="small"
                aria-label={t('vanBanNhiemVu.themNhanh.vaiTro')}
                className="w-36"
                value={p.role}
                onChange={(role) => setRole(p.user_id, role)}
                options={roleOptions}
              />
              <Button
                variant="ghost"
                size="sm"
                icon={<CloseOutlined />}
                aria-label={t('vanBanNhiemVu.form.boNguoi', { ten: p.user_name })}
                onClick={() => onChange(value.filter((x) => x.user_id !== p.user_id))}
              />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
